export const TRANSCRIPTION_FEATURES = [
  {
    plan: "Randi Scribe",
    list: [
      "Dataprosessering og lagring innenfor EU",
      "Transkripter i alle formater",
      "Høy nøyaktighet (OpenAI Whisper v3)",
      "AES-256 kryptert lagring",
      "Rask transkriberingstid (GPU akselerert)",
      "Opp til 20 timer transkribering",
    ],
  },
  {
    plan: "Randi Social",
    list: [
      "Dataprosessering og lagring innenfor EU",
      "Transkripter i alle formater",
      "Høy nøyaktighet (OpenAI Whisper v3)",
      "AES-256 kryptert lagring",
      "Rask transkriberingstid (GPU akselerert)",
      "Opp til 40 timer transkribering",
    ],
  },
  {
    plan: "Randi Go",
    list: [
      "Dataprosessering og lagring innenfor EU",
      "Transkripter i alle formater",
      "Høy nøyaktighet (OpenAI Whisper v3)",
      "AES-256 kryptert lagring",
      "Rask transkriberingstid (GPU akselerert)",
      "Transkribere flere lyd/videofiler samtidig",
      "Ubegrenset transkriberingtid",
    ],
  },
];

export const VIDEO_EDITING_FEATURES = [
  {
    plan: "Randi Scribe",
    list: [
      "Vannmerke på video",
      "Opp til 4 videoeksporteringer",
      "Videolengde opp til 20 minutter",
      "Videokvalitet opp til 720p",
    ],
  },
  {
    plan: "Randi Social",
    list: [
      "Ingen vannmerke på video",
      "Ubegrenset antall videoeksporteringer",
      "Videolengde opp til 20 minutter",
      "Videokvalitet opp til 1080p",
    ],
  },
  {
    plan: "Randi Go",
    list: [
      "Ingen vannmerke på video",
      "Ubegrenset antall videoeksporteringer",
      "Ubegrenset videolengde",
      "Videokvalitet opp til 4K",
    ],
  },
];

export const SUBSCRIPTION_TIERS = [
  {
    title: "Randi Scribe",
    prices: [119, 999],
    description:
      "For deg som kun trenger mulighet til å transkribere lyd og video. Bruk Randi Scribe for å transkribere opp til 20 timer per måned.",
  },
  {
    title: "Randi Social",
    prices: [149, 1699],
    description:
      "Teksting av reels, stories og videoer på alle sosiale medier. Opp til 40 timer transkribering per måned med inntil 20 minutters lengde.",
  },
  {
    title: "Randi Go",
    prices: [349, 3999],
    description:
      "For deg som vil ha ubegrenset tilgang til alle funksjonene Randi tilbyr. Last opp ubegrenset antall videoer med ubegrenset lengde.",
  },
];
